declare var ENV: {
  MAPBOX_ACCESS_TOKEN: string,
};

declare var window: {
  outputUI: Function,
  createMap: Function,
  fitBounds: Function,
  openTooltipForFeature: Function,
  mapboxgl: {},
};

interface FeatureCollection extends GeoJSON.FeatureCollection {
  bounds: {
    longitude_left: number;
    latitude_top: number;
    longitude_right: number;
    latitude_bottom: number;
  };
}

import 'whatwg-fetch';
import * as mapboxgl from 'mapbox-gl';
import fitBounds from './helpers/fitBounds';
import getSource from './getSource';
import addClusters from './addClusters';
import { openTooltip, closeTooltips, openTooltipForFeature } from './tooltips';
import hasTouchEvents from './helpers/hasTouchEvents';
import { unclusteredPointStyle } from './style';

const MAP_STYLE = 'mapbox://styles/orangetalent/cjizpw5p40tzz2rprmdhaylxp';

const touchEvents = hasTouchEvents();

export function outputUI(map: any) {
  return new Promise((resolve) => {
    addClusters(map, 'geojson');

    map.addLayer(Object.assign(
      {
        id: 'unclustered_point',
        type: 'circle',
        source: 'geojson',
        interactive: true,
        filter: ['!=', 'cluster', true],
      },
      unclusteredPointStyle,
    ));

    map.on('click', 'unclustered_point', (e: any) => {
      closeTooltips();
      openTooltip(map, e);
    });

    if (!touchEvents) {
      map.on('mouseenter', 'unclustered_point', (e: any) => {
        closeTooltips();
        openTooltip(map, e);
      });
    }

    map.on('click', 'cluster', (e: any) => {
      map.easeTo({
        center: [e.lngLat.lng, e.lngLat.lat],
        zoom: map.getZoom() + 1,
      });
    });

    resolve(null);
  });
}

export function createMap(mapElement: HTMLElement) {
  Object.getOwnPropertyDescriptor(mapboxgl, 'accessToken').set(ENV.MAPBOX_ACCESS_TOKEN);

  return new mapboxgl.Map({
    container: mapElement,
    style: MAP_STYLE,
    renderWorldCopies: false,
    maxZoom: 14,
  });
}

window.createMap = createMap;
window.outputUI = outputUI;
window.fitBounds = fitBounds;
window.openTooltipForFeature = openTooltipForFeature;
window.mapboxgl = mapboxgl;

const autoBind = document.querySelectorAll('.js-map-autobind');
const autoBindArr = Array.prototype.slice.call(autoBind);

autoBindArr.forEach((mapElement: HTMLElement) => {
  const map = createMap(mapElement);

  if (typeof mapElement.getAttribute('data-preset-bounds') !== 'undefined') {
    fitBounds(map, JSON.parse(mapElement.getAttribute('data-preset-bounds')));
  }

  if (typeof mapElement.getAttribute('data-non-interaction') !== 'undefined') {
    map.addControl(new mapboxgl.NavigationControl());
    map.scrollZoom.disable();
  }

  map.on('load', () => {
    getSource(mapElement.getAttribute('data-geojson'))
      .then((res: FeatureCollection) => {
        map.addLayer({
          id: 'geojson',
          type: 'symbol',
          source: {
            type: 'geojson',
            data: res,
            cluster: true,
            clusterRadius: 75,
          },
        });

        fitBounds(map, res.bounds);
        outputUI(map);
      })
      .catch((err) => {
        console.error(err);
      });
  });

  // map.on('click', (event) => {
  //   const longitude = event.lngLat.lng;
  //   const latitude = event.lngLat.lat;
  //
  //   if (map.getZoom() <= 5) {
  //     map.fitBounds(
  //       new mapboxgl.LngLatBounds(
  //         new mapboxgl.LngLat(longitude, latitude),
  //         new mapboxgl.LngLat(longitude, latitude),
  //       ), {zoom: 5}
  //     );
  //   }
  // });
});
